export enum EmpPrefixEnum{
Mr = 'Mr',
Miss = 'Miss',
Mrs = 'Mrs'

}